






























import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import { WizardState } from "@/shared/interfaces/WizardState.interface";

export default Vue.extend ({
    name: "NextPreviousButton",

    components: {
        iwButtonLoading: iwButtonLoading,
    },

    props: {
        labelNextButton: {
            type: String,
            required: false,
            default: "next"
        },
        disableNextButton: {
            type: Boolean,
            required: false,
            default: false
        },
        disablePreviousButton: {
            type: Boolean,
            required: false,
            default: false
        },
        hideNextButton: {
            type: Boolean,
            required: false,
            default: false
        },
        hidePreviousButton: {
            type: Boolean,
            required: false,
            default: false
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
        }),

        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
            isEditionMode: "FormModule/getIsEditionMode",
        }),
    },

    methods: {
        onNext: function() {
            this.$emit("next");
        },

        onPrevious: function(){
            this.$emit("previous");
        },
    }
});
